import React, { useEffect, useRef, useState } from 'react';
import { motion, useInView, useReducedMotion } from 'framer-motion';

function Counter({ target, suffix = '' }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true });
  const reduceMotion = useReducedMotion();
  const [value, setValue] = useState(0);

  useEffect(() => {
    if (!inView) return;
    if (reduceMotion) {
      setValue(target);
      return;
    }

    let frame;
    const start = performance.now();
    const duration = 1400;

    const update = (time) => {
      const progress = Math.min((time - start) / duration, 1);
      setValue(Math.round(target * (1 - Math.pow(1 - progress, 3))));
      if (progress < 1) frame = requestAnimationFrame(update);
    };

    frame = requestAnimationFrame(update);
    return () => cancelAnimationFrame(frame);
  }, [inView, reduceMotion, target]);

  return <strong ref={ref}>{value}{suffix}</strong>;
}

function Stats() {
  const stats = [
    { target: 20, suffix: '+', label: 'Years of Experience' },
    { target: 500, suffix: '+', label: 'Projects Completed' },
    { target: 100, suffix: '%', label: 'On Time & On Budget' }
  ];

  return (
    <section className="stats" aria-label="Company statistics">
      <div className="container stats-grid">
        {stats.map((stat) => (
          <motion.div
            key={stat.label}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <Counter target={stat.target} suffix={stat.suffix} />
            <span>{stat.label}</span>
          </motion.div>
        ))}
        <motion.div initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }}>
          <strong>NAPCO</strong>
          <span>Certified Resurfacing Specialists</span>
        </motion.div>
      </div>
      <p className="verification-note">Project count should be confirmed with the client before launch.</p>
    </section>
  );
}

export default Stats;